export default {
  imageSlide: {
    position: 'relative',
    objectFit: ['contain', 'contain', 'cover'],
    objectPosition: 'left',
    height: ['calc(100vh - 96px)', 'calc(100vh - 96px)', '73.3072917vw', '73.3072917vw', '46.875vw'],
    width: 'auto',
    img: {
      position: 'static !important',
      width: 'auto !important',
      height: ['calc(100vh - 96px) !important', 'calc(100vh - 96px) !important', '73.3072917vw !important', '73.3072917vw !important', '46.875vw !important']
    }
  }
};